<div id="gantry-startup-card">
  <ng-container
    *ngTemplateOutlet="selectionModel.detailEvent ? singleGrid : doubleGrid"
  ></ng-container>
</div>

<ng-template #doubleGrid>
  <div class="cts-startup-details-grid">
    <div class="cts-action-grid common-grid">
      <div class="action-label">
        <sh-text class="font-weight-700" id="dg-label-event-analysis">
          {{ 'cts.gantry.eventAnalysis' | translate }}
        </sh-text>
      </div>

      <div class="empty-column-8"></div>

      <div class="pane-actions">
        <app-cts-gantry-startup-actions
          id="dg-1st-startup-actions"
          [systemDetails]="systemDetails"
          buttonName="logs"
          [events]="events"
          [buttonFn]="openLogs(selectionModel.ctsEvent.first!, FIRST)"
          [selectedEvent]="selectionModel.ctsEvent.first"
          (selectedEventChange)="on1stSelectedEventChange($event)"
        ></app-cts-gantry-startup-actions>
      </div>

      <div class="empty-column-60"></div>

      <div class="pane-actions">
        <app-cts-gantry-startup-actions
          id="dg-2nd-startup-actions"
          [systemDetails]="systemDetails"
          buttonName="logs"
          [events]="events"
          [buttonFn]="openLogs(selectionModel.ctsEvent.second!, SECOND)"
          [selectedEvent]="selectionModel.ctsEvent.second"
          (selectedEventChange)="on2ndSelectedEventChange($event)"
        ></app-cts-gantry-startup-actions>
      </div>
    </div>

    <div class="empty-row-10"></div>

    <div class="cts-startup-head-grid common-grid">
      <div class="functional-unit-label">
        <sh-text
          id="dg-fn-unit-label"
          color="secondary"
          class="font-weight-700"
        >
          {{ 'cts.gantry.functionalUnits' | translate }}
        </sh-text>
      </div>

      <div class="empty-column-8"></div>

      <div class="step-list">
        <app-cts-gantry-functional-unit-step-labels
          id="dg-1st-step-labels"
          [labels]="
            mapStepNames(selectionModel.fUnitData.getFirstFnUnitSteps())
          "
        ></app-cts-gantry-functional-unit-step-labels>
      </div>

      <div class="empty-column-60"></div>

      <div class="step-list">
        <app-cts-gantry-functional-unit-step-labels
          id="dg-2nd-step-labels"
          [labels]="
            mapStepNames(selectionModel.fUnitData.getSecondFnUnitSteps())
          "
        ></app-cts-gantry-functional-unit-step-labels>
      </div>
    </div>

    <api-call-gate [apiCall]="[gantryworkflow1st, gantryworkflow2nd]">
      <ng-template #lastSuccessfulData>
        <div class="cts-startup-grid common-grid">
          <div class="functional-unit-list">
            <app-cts-gantry-functional-unit-list
              id="dg-functional-unit-list"
              [functionalUnits]="
                selectionModel.fUnitData.getFunctionalUnitNameList()
              "
            ></app-cts-gantry-functional-unit-list>
          </div>

          <div class="empty-column-8"></div>

          <div class="step-list">
            <app-cts-gantry-functional-unit-grid
              id="dg-1st-functional-unit-grid"
              [functionalUnitList]="
                selectionModel.fUnitData.getFirstFnUnitCheckList()
              "
              [stepsDefinition]="selectionModel.fUnitData.getFirstFnUnitSteps()"
            ></app-cts-gantry-functional-unit-grid>
          </div>

          <div class="empty-column-60"></div>

          <div class="step-list">
            <app-cts-gantry-functional-unit-grid
              id="dg-2nd-functional-unit-grid"
              [functionalUnitList]="
                selectionModel.fUnitData.getSecondFnUnitCheckList()
              "
              [stepsDefinition]="
                selectionModel.fUnitData.getSecondFnUnitSteps()
              "
            ></app-cts-gantry-functional-unit-grid>
          </div>
        </div>
      </ng-template>
    </api-call-gate>

    <div class="empty-row-16"></div>

    <div class="legends">
      <app-cts-gantry-functional-unit-grid-legend
        id="dg-functional-unit-grid-legend"
      ></app-cts-gantry-functional-unit-grid-legend>
    </div>
  </div>
</ng-template>

<ng-template #singleGrid>
  <div class="cts-startup-details-grid">
    <div class="cts-action-grid common-grid common-grid--show-log">
      <div class="action-label">
        <sh-text class="font-weight-700" id="sg-label-event-analysis">
          {{ 'cts.gantry.eventAnalysis' | translate }}
        </sh-text>
      </div>

      <div class="empty-column-8"></div>

      <div class="pane-actions">
        <app-cts-gantry-startup-actions
          id="sg-startup-actions"
          [systemDetails]="systemDetails"
          buttonName="compare"
          [events]="events"
          [buttonFn]="openCompare"
          [selectedEvent]="selectionModel.detailEvent"
          (selectedEventChange)="onDetailSelectedEventChange($event)"
        ></app-cts-gantry-startup-actions>
      </div>
    </div>

    <div class="empty-row-10"></div>

    <div class="cts-startup-head-grid common-grid common-grid--show-log">
      <div class="functional-unit-label">
        <sh-text
          id="sg-fn-unit-label"
          color="secondary"
          class="font-weight-700"
        >
          {{ 'cts.gantry.functionalUnits' | translate }}
        </sh-text>
      </div>

      <div class="empty-column-8"></div>

      <div class="step-list step-labels">
        <app-cts-gantry-functional-unit-step-labels
          id="sg-step-labels"
          [labels]="
            mapStepNames(selectionModel.detailFUnitData?.functionalUnits.steps)
          "
        ></app-cts-gantry-functional-unit-step-labels>
      </div>
    </div>

    <api-call-gate [apiCall]="[gantryworkflowDetail]">
      <ng-template #lastSuccessfulData>
        <div class="cts-startup-grid common-grid common-grid--show-log">
          <div class="functional-unit-list">
            <app-cts-gantry-functional-unit-list
              id="sg-functional-unit-list"
              [functionalUnits]="
                selectionModel.detailFUnitData?.functionalUnits.names
              "
            ></app-cts-gantry-functional-unit-list>
          </div>

          <div class="empty-column-8"></div>

          <div class="step-list">
            <app-cts-gantry-functional-unit-grid
              id="sg-functional-unit-grid"
              [functionalUnitList]="
                selectionModel.getDetailFUnitDataCheckList()
              "
              [stepsDefinition]="
                selectionModel.detailFUnitData?.functionalUnits.steps
              "
            ></app-cts-gantry-functional-unit-grid>
          </div>
        </div>
      </ng-template>
    </api-call-gate>

    <div class="empty-row-16"></div>

    <div class="legends">
      <app-cts-gantry-functional-unit-grid-legend
        id="sg-functional-unit-grid-legend"
      ></app-cts-gantry-functional-unit-grid-legend>
    </div>
  </div>
</ng-template>
